import { range } from 'src/utils'

export const shortcuts = Object.freeze({
  nextMonth: ['ctrl', 'arrowright'],
  prevMonth: ['ctrl', 'arrowleft'],
  nextEmployee: ['e'],
  prevEmployee: ['q'],
  joinLines: ['j'],
  consult: ['shift', 'b'],
  selectComp: ['shift', 'c'],
  selectEmp: ['shift', 'e'],
  changeCompanyLoadType: ['shift', 't'],
  showGuide: ['shift', '?'],
  changeOrderEmps: ['shift', 'q'],
  focusSomas: ['shift', 'a'],
  unselectAllLines: ['shift', 'z'],
  recalculateSelected: ['shift', 'r'],
  recalculateAll: ['shift', 'p']
})

export function shortcutsHandler (event) {
  const actions = {
    joinLines: joinLines.bind(this),
    nextEmployee: nextEmployee.bind(this),
    prevEmployee: prevEmployee.bind(this),
    nextMonth: nextMonth.bind(this),
    prevMonth: prevMonth.bind(this),
    selectComp: selectComp.bind(this),
    selectEmp: selectEmp.bind(this),
    changeCompanyLoadType: changeCompanyLoadType.bind(this),
    changeOrderEmps: changeOrderEmps.bind(this),
    recalculateSelected: recalculateSelected.bind(this),
    unselectAllLines: unselectAllLines.bind(this),
    recalculateAll: recalculateAll.bind(this),
    consult: () => this.consult,
    focusSomas: () => this.$emit('focusSomas'),
    showGuide: () => this.$modal.show('guide-timesheet')

  }

  return actions[event.srcKey]()
}

function joinLines () {
  this.$store.dispatch('sheet/mergeSelectedLines')
}

function nextEmployee () {
  if (this.type === 'employee') {
    this.$store.dispatch('timesheet/header/nextEmployee')
  }
}

function prevEmployee () {
  if (this.type === 'employee') {
    this.$store.dispatch('timesheet/header/prevEmployee')
  }
}

function nextMonth () {
  this.$store.dispatch('timesheet/header/calcPeriod', { type: 'add' })
}

function prevMonth () {
  this.$store.dispatch('timesheet/header/calcPeriod', { type: 'subtract' })
}

function selectComp () {
  this.$refs.employeeSelector.hidePopup()
  this.$refs.companySelector.focusInput()
}

function selectEmp () {
  this.$refs.companySelector.hidePopup()
  this.$refs.employeeSelector.focusInput()
}

function changeCompanyLoadType () {
  this.typeLoadCompany = this.typeLoadCompany === 'perday' ? 'peremp' : 'perday'
}

function recalculateSelected () {
  if (this.$store.getters['timesheet/sheet'].selectedLines.length) {
    this.$store.dispatch('sheet/recalculateSelectedLines')
  } else if (document.activeElement.tagName === 'INPUT' && document.activeElement.parentNode.__vue__) {
    const rowIndex = document.activeElement.parentNode.__vue__.rowNumber
    this.$store.dispatch('sheet/recalcLines', [rowIndex])
  }
}

function unselectAllLines () {
  this.$store.commit('sheet/selectedLines', [])
}

function recalculateAll () {
  const {lines} = this.$store.getters['timesheet/sheet']

  if (this.$store.state.timesheet.header.type === 'employee' && lines.find(l => l.dayJourney && l.dayJourney.locked)) {
    return
  }

  this.$store.dispatch('sheet/recalcLines',
    range(0, this.$store.getters['timesheet/sheet'].lines.length - 1)
  )
}

function changeOrderEmps () {
  this.typeEmployeeOrder = this.typeEmployeeOrder === 'name' ? 'code' : 'name'
}
